import { ShiftIntervalCategory } from '@amzn/atoz-shiftapp-types';
import { useShiftIntervalMapping } from '../../../../hooks/useShiftIntervalMapping/useShiftIntervalMapping.web';
export var useEventTypeMapping = function () {
    // hooks are being invoked non-iteratively because linter otherwise considers it a rules of hooks violation
    var intervalMappings = [];
    intervalMappings.push([
        ShiftIntervalCategory.Work,
        useShiftIntervalMapping(ShiftIntervalCategory.Work)
    ]);
    intervalMappings.push([
        ShiftIntervalCategory.Breaks,
        useShiftIntervalMapping(ShiftIntervalCategory.Breaks)
    ]);
    intervalMappings.push([
        ShiftIntervalCategory.Meetings,
        useShiftIntervalMapping(ShiftIntervalCategory.Meetings)
    ]);
    intervalMappings.push([
        ShiftIntervalCategory.AdditionalTime,
        useShiftIntervalMapping(ShiftIntervalCategory.AdditionalTime)
    ]);
    intervalMappings.push([
        ShiftIntervalCategory.TimeOff,
        useShiftIntervalMapping(ShiftIntervalCategory.TimeOff)
    ]);
    intervalMappings.push([
        ShiftIntervalCategory.Miscellaneous,
        useShiftIntervalMapping(ShiftIntervalCategory.Miscellaneous)
    ]);
    var eventTypeMapping = new Map(intervalMappings.map(function (_a) {
        var category = _a[0], intervalMapping = _a[1];
        var icon = intervalMapping.icon, label = intervalMapping.label, _b = intervalMapping.color, primaryColor = _b.eventBlockColor, highlightColor = _b.eventBlockBorderColor;
        return [category, { icon: icon, label: label, primaryColor: primaryColor, highlightColor: highlightColor }];
    }));
    var fallbackEventDetails = eventTypeMapping.get(ShiftIntervalCategory.Miscellaneous);
    return { eventTypeMapping: eventTypeMapping, fallbackEventDetails: fallbackEventDetails };
};
